
namespace TabAurous.Purchase {

    @Serenity.Decorators.registerClass()
    export class PurchaseLaborGrid extends Serenity.EntityGrid<PurchaseLaborRow, any> {
        protected getColumnsKey() { return 'Purchase.PurchaseLabor'; } 
        protected getIdProperty() { return PurchaseLaborRow.idProperty; }
        protected getInsertPermission() { return PurchaseLaborRow.insertPermission; }
        protected getLocalTextPrefix() { return PurchaseLaborRow.localTextPrefix; }
        protected getService() { return PurchaseLaborService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}